import { Box, IconButton, Typography, Collapse, Button, TextField } from '@mui/material';
import React, { useState } from 'react';
import useDataCompanyUsers from '../../hooks/useDataCompanyUsers';
import UserCard from './UserCard';
import AddCircleOutlineRoundedIcon from '@mui/icons-material/AddCircleOutlineRounded';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ModalWrapper from '../Modals/ModalWrapper';
import CreateModal from './CreateModal';
import CustomCircularProgress from '../Common/Preloader';
import { useAuth } from '../../store/auth.store';
import TourExample from './TourExample';
import { useTour } from '../../provider/TourGuide';
import UserCardMock from './UserCardMock';
import EditIcon from '@mui/icons-material/Edit';
import { useNavigate } from 'react-router-dom';
import URLS from '../../enums/route';

const CompanyUsersList = () => {
    const { data, isLoading } = useDataCompanyUsers();
    const {openCreateUserModal, setOpenCreateUserModal, bussniesNumber} = useTour()
    const [expanded, setExpanded] = useState(true);
    const {user} = useAuth()
    const navigate = useNavigate()
    const handleExpandClick = () => {
        setExpanded(!expanded);
    };

    return (
        <Box>
            {isLoading ?
                <Box sx={{display:'flex', justifyContent:'center', alignItems:'center', margin:'20px 0'}}>
                    <CustomCircularProgress/>
                </Box>
            :
            <Box sx={{ display: 'flex', justifyContent: 'space-between', cursor: 'pointer', mt:'20px', alignItems:'center' }} onClick={handleExpandClick}>
                <Box sx={{ display: 'flex', gap: '10px' }}>
                    <Typography color='#154D72' fontWeight={700} lineHeight={'21px'} fontSize={'15px'}>
                        עובדים בארגון {`(${data?.length})`}
                    </Typography>
                </Box>
                
                <Box>
                    {user?.permission?.permissionDetaileds[0]?.isArchitecture &&
                        <>
                        <IconButton onClick={() => navigate(URLS.PERMISSION.LINK)}>
                            <EditIcon sx={{color:'#154D72', fontSize:'19px'}} />
                        </IconButton> 
                        {expanded &&
                            <IconButton
                                onClick={(e) => {setOpenCreateUserModal(true); e.stopPropagation();}}
                            >
                                <AddCircleOutlineRoundedIcon sx={{color:'#154D72'}}/>
                            </IconButton>
                        }       
             
                        </>
                    }
                    <IconButton aria-expanded={expanded} aria-label="show more">
                        {expanded ? <ExpandLessIcon sx={{color:'#154D72'}}/> : <ExpandMoreIcon sx={{color:'#154D72'}}/>}
                    </IconButton>
                </Box>
            
            </Box>
            }
            {bussniesNumber === 1 &&
                <TourExample/>
            }
            {bussniesNumber === 4 && 
                <UserCardMock/>
            }

            <Collapse in={expanded} timeout="auto" unmountOnExit>
                {data?.map((item, index) => (
                    <UserCard key={index} item={item} />
                ))}
            </Collapse>
            <CreateModal openModal={openCreateUserModal} setOpenModal={setOpenCreateUserModal}/>
        </Box>
    );
};

export default CompanyUsersList;
